<template>
    <v-app>
        <approvalName :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Approval Name</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                      
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>


                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openAddModule"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Approval Name
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                     :headers="headers"
                                     :items="getSchema"
                                     :loading="loading"
                                     v-model:items-per-page="itemsPerPage"
                                     :search="search"
                                     :hover="true"                    
                                     density="compact">

                                        <template #item.index="{ index }">
                                            {{ ++index }}
                                        </template>
                                        <template #item.module="{ item }">
                                            {{ item.module?.name }}
                                        </template>
                                        <template #item.sub_module="{ item }">
                                            {{ item.sub_module?.name }}
                                        </template>
                                        <template #item.menu="{ item }">
                                            {{ item.menu?.name || item.menu || '-' }}
                                        </template>
                                        <template #item.icon="{ item }">
                                             <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                            >
                                               {{ item.icon }}
                                            </v-icon>
                                        </template>
                                        
                                        <template #item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template #item.is_forward="{ item }">
                                            <span>{{ item.is_forward == 1 || item.is_forward == '1' ? 'Yes' : 'No' }}</span>
                                        </template>

                                        <template #item.actions="{ item }">
                                            <v-icon
                                              
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                               mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import approvalName  from '@/components/module/administration/approvalManagement/approvalName.vue';
export default {
        components: {
            approvalName 
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code",align: "center" , width: "10%", sortable: false },
                { title: "Name", key: "name",align: "left" , width: "20%", sortable: false },
                { title: "Tag",align: "left", key: "tag", sortable: true },
                { title: "Module",align: "left", key: "module", sortable: true },
                { title: "Sub Module",align: "left", key: "sub_module", sortable: true },
                {title : "Menu", align: "center", key: "menu", sortable: true },
                // { title: "Show URL",align: "left", key: "show_url", sortable: true },
                // { title: "Edit URL",align: "left", key: "edit_url", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Is Forward", align: "center", key: "is_forward", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getApprovalNameList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getApprovalNameList').then((response) => {
                    this.loading = false;
                })
            };
        },
        computed:{
            getSchema() {
                return this.$store.getters.getApprovalNameList;
            },
        },
        methods: {
            openAddModule() {
                this.data = {
                    id: '',
                    name: '',
                    icon: '',
                    sl: '',
                    status: 1,
                };
                this.dialog = true;

            },
            editItem(item){
                this.data = { ...item };
                this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Name', 'Tag','Show URL', 'Update URL','Status', 'Is Forward'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.name, item.tag, item.show_url, item.edit_url, item.status == 1 ? 'Active' : 'Inactive', (item.is_forward == 1 || item.is_forward == '1') ? 'Yes' : 'No']);
                this.$exportTableToPDF(columns,rows,'Approval Name','approval_name_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Name', 'Tag','Show URL', 'Update URL','Status', 'Is Forward']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.tag, item.show_url, item.edit_url, item.status == 1 ? 'Active' : 'Inactive', (item.is_forward == 1 || item.is_forward == '1') ? 'Yes' : 'No']);
                });
                this.$exportTableToExcel(data,'approval_name_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Name', 'Tag','Show URL', 'Update URL','Status', 'Is Forward']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.tag, item.show_url, item.edit_url, item.status == 1 ? 'Active' : 'Inactive', (item.is_forward == 1 || item.is_forward == '1') ? 'Yes' : 'No']);
                });

                this.$exportTableToCSV(data,'approval_name_list_' + this.$fileDate());
            },
        },
        mounted() {

        }  
    }
</script>